"use client";
import React from "react";
import { HeaderTextImageCarouselSection } from "@/src/api/fetchHomeSections/types";
import { useFindSection } from "@/src/hooks/useFindSection";
import { HomeSectionProps } from "@/src/types/home-section-props";
import {
  AnimatedImage,
  AnimatedText,
  HomeSectionContainer,
  LogosCarousel,
} from "@/src/components";
import { useParseLinks } from "@/src/hooks/useParseLinks";

const OurCredentials: React.FC<HomeSectionProps> = ({ data }) => {
  const foundSection = useFindSection(data, "header+text+image+carousel");
  const section = foundSection as HeaderTextImageCarouselSection | undefined;

  const { parseLinks } = useParseLinks();

  if (!section) return null;

  const logos =
    section.carousel
      ?.filter((item) => item.image?.url)
      .map((item) => ({
        src: item.image?.url || "",
        link:
          typeof item.link === "object" && item.link?.url ? item.link.url : "#",
      })) || [];

  const shouldBeFullWidth = !section.image?.url;

  return (
    <>
      {logos.length > 0 && (
        <HomeSectionContainer>
          <LogosCarousel logos={logos} />
        </HomeSectionContainer>
      )}
      <HomeSectionContainer {...(shouldBeFullWidth ? { fullWidth: true } : {})}>
        {section.image?.url && (
          <AnimatedImage
            src={section.image.url}
            alt={section.image.title || "Our Credentials"}
            direction="left"
            width={750}
            height={440}
          />
        )}
        <AnimatedText
          direction={shouldBeFullWidth ? "bottom" : "right"}
          center={shouldBeFullWidth ? true : false}
        >
          <div className="text-center">
            <p className="home-section-title">{section.header}</p>
          </div>
          <p className="home-section-text">
            {parseLinks(section.suptitile || "")}
          </p>
        </AnimatedText>
      </HomeSectionContainer>
    </>
  );
};

export default OurCredentials;
